<template>
	<div class="nk-dialog" tabindex="10">
		<div class="nd-dim" @click.stop="dimClicked" v-if="lastMessage">
			<div class="nd-dim-inner d-flex flex-column justify-content-center align-items-center" ref="parent_dragable">
				<vue-draggable-resizable :drag-handle="'.nm-header'" class-name-active="my-active-class" w="auto" h="auto" :resizable="false" :x="position.left" :y="position.top" @dragging="onDrag" @dragStop="onDragStop" class-name="nm-dim-inner.modal-item-locker.modal-item">
					<div class="nd-dim-box d-flex flex-column" ref="dimBox" tabindex="0" :class="[lastMessageType, { 'lg-dialog': localButtons.filter(x => x.visible).length > 3, 'md-dialog': localButtons.filter(x => x.visible).length === 3 }]">
						<div class="nd-header nm-header">
							<!-- <div class="nd-statusbar">{{ $t('nikan') }}</div> -->
							<div class="nd-title">{{ lastMessage.title }}</div>
							<div class="nd-dismiss">
								<a href="#" @click.stop="closeButtonClicked">
									<icon :icon="['fas', 'times']" />
								</a>
							</div>
						</div>
						<div class="nd-body d-flex flex-column">
							<div class="d-flex nd-content-box">
								<!-- <div><i :class="`fal fa-${getIconNameByMessageType()} fa-3x`"></i></div> -->
								<div>
									<nk-lottie :options="getLottieOptions()" />
								</div>
								<div class="nd-content nd-body" v-html="lastMessage.body"></div>
							</div>
							<div class="nd-buttons" ref="buttons">
								<div tabscope class="d-flex justify-content-center align-items-stretch">
									<nk-button v-for="(b, i) in localButtons.filter(x => x.visible)" :ref="`button_${i}`" tabindex="0" :key="i" :tabindex="i + 1" class="btn btn-block btn-sm" :class="lastMessageButtonsClass(b)" :options="b" @click="buttonClicked"></nk-button>
								</div>
							</div>
							<div class="nd-timer" v-if="progress.max > -1">
								<div class="progress">
									<div class="progress-bar" role="progressbar" :style="`width: ${progressPercent}%`" :aria-valuenow="progress.value" aria-valuemin="0" :aria-valuemax="progress.max"></div>
								</div>
							</div>
						</div>
					</div>

				</vue-draggable-resizable>

			</div>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { mapActions, mapGetters } from 'vuex'
	import TabOrder from '~/statics/taborder-functions'

	const lottieFiles = import.meta.glob(
		'/src/assets/lottie/*.json',
		{ eager: true, import: 'default' }
	)

	export default {
		props: {
			messages: {
				type: Array
			}
		},
		data() {
			return {
				progress: {
					max: -1,
					value: 0
				},
				position: {
					top: null,
					left: null,
					width: null,
					height: null,
				},
			}
		},
		computed: {
			...mapGetters({
				getActiveState: 'appStates/getActiveByKey',
			}),
			localButtons() {
				if (!this.lastMessage || !this.lastMessage.buttons || this.lastMessage.buttons.length === 0) {
					return []
				}

				return this.lastMessage.buttons.map(b => {
					return _.extend({
						visible: true,
						shortcut: {}
					}, b)
				})
			},
			lastMessage() {
				if (this.messages == null) {
					return
				}

				var len = this.messages.length
				if (len > 0) {
					var msg = this.messages[0]
					if (typeof msg.buttons === 'undefined') {
						msg.buttons = []
					}

					return msg
				}

				return undefined
			},
			progressPercent() {
				return (this.progress.value * 100) / this.progress.max
			},
			lastMessageType() {
				if (this.lastMessage && this.lastMessage.type) {
					switch (this.lastMessage.type) {
						case 'danger':
							return 'error'
						case 'error':
						case 'success':
						case 'warning':
						case 'info':
							return this.lastMessage.type
					}
				}

				return 'info'
			}
		},
		created() {

		},
		mounted() {
		},
		updated() {
			this.defer(this.subscribeKeys, 1)

			if (this.$refs.dimBox) {
				this.defer(() => this.$refs.dimBox.focus(), 50)
			}
			this.defer(() => {
				$(this.$refs.dimBox).addClass('show')
			}, 1)
			this.getLottieOptions()
		},
		methods: {
			...mapActions(['removeMessage']),
			preparePosition() {
				if (this.stateEnabled) {
					this.currentState = this.getActiveState(this.stateUID)
					if (this.currentState && this.currentState.value) {
						this.position = _.extend({}, this.position, this.currentState.value)
						return
					}
				}
				let windowWidth = this.$refs.parent_dragable.clientWidth
				let windowHeight = this.$refs.parent_dragable.clientHeight
				let top = Math.round((windowHeight - 350) / 2)
				let left = Math.round((windowWidth - 350) / 2)
				left = Math.max(left, 0) // in mobile view modal will be pushed out of the screen
				top = Math.max(top, 0)
				let tmp = {
					top: top,
					left: left,
					height: 350,
					width: 350,
				}

				this.position = { ...this.position, ...tmp }
			},
			onDrag(x, y) {
				this.position.left = x
				this.position.top = y
			},
			onDragStop() {
				// console.log('this.position', this.position)
				let windowHeight = window.innerHeight
				let windowWidth = window.innerWidth
				// console.log('windowWidth', window.innerWidth, window.innerHeight)
				if (this.position.left <= -windowWidth / 2) {
					this.position.left = -windowWidth / 2
				} else if (this.position.left >= windowWidth * 0.6) {
					this.position.left = windowWidth * 0.6
				} else if (this.position.top <= -windowHeight / 5) {
					this.position.top = -windowHeight / 5
				} else if (this.position.top >= windowHeight / 2) {
					this.position.top = windowHeight / 2
				}
			},

			dimClicked(e) {
				var $target = $(e.target)
				if (!$target.hasClass('nd-dim-box') && !$target.parents('.nd-dim-box').length > 0 && !$(this.$refs.dimBox).hasClass('shake')) {
					$(this.$refs.dimBox).addClass('shake')
					this.$refs.dimBox.focus()
					this.defer(this.stopShaking, 1000)
				}
			},
			stopShaking() {
				$(this.$refs.dimBox).removeClass('shake')
			},
			incrementCounter(timer) {
				this.progress.value += 1

				if (this.progress.value >= this.progress.max) {
					clearInterval(timer)
				}
			},
			lastMessageButtonsClass(button) {
				var obj = {
					'btn-outline-secondary': !button.isPrimary,
					'btn-primary': button.isPrimary,
					// 'btn-danger': button.isPrimary && (this.lastMessage.type === 'error' || this.lastMessage.type === 'danger'),
					// 'btn-success': button.isPrimary && (this.lastMessage.type === 'success'),
					// 'btn-info': button.isPrimary && !(this.lastMessage.type === 'error' || this.lastMessage.type === 'danger' || this.lastMessage.type === 'success'),
					// 'btn-warning': button.isPrimary && !(this.lastMessageType === 'info' || this.lastMessage.type === 'error' || this.lastMessage.type === 'danger' || this.lastMessage.type === 'success')
				}
				return obj
			},
			getLottieOptions() {
				return {
					styles: {
						width: '60px',
						height: '60px',
					},
					defaultOptions: {
						animationData: lottieFiles[`/src/assets/lottie/${this.lastMessageType}.json`],
						loop: false,
					}
				}
			},
			closeButtonClicked(e) {
				$(this.$refs.dimBox).removeClass('show')
				this.defer(() => {
					let flag = false
					let _buttons = [...this.localButtons]
					for (let i = 0; i < _buttons.length; i++) {
						let b = _buttons[i]

						if (b.isCancel === true) {
							this.buttonClicked(b, e)
							flag = true
						}
					}

					if (!flag && _buttons.length === 1) {
						let b = _buttons[0]
						this.buttonClicked(b, e)
						flag = true
					}

					if (!flag) {
						this.returnFocusToPage(this.lastMessage.focusedEl)

						if (typeof this.lastMessage.reject === 'function') {
							this.lastMessage.reject()
						}

						this.closeModalInner(e)
					}
				}, (this.localButtons || []).findIndex(x => x.isCancel) > -1 ? 0 : 300)// if cancel button exist closing delay done by that defer button
			},
			closeModalInner(e) {
				if (e) {
					e.preventDefault()
				}

				this.removeMessage()
			},
			buttonClicked(button, e) {
				if (e) {
					e.preventDefault()
				}

				$(this.$refs.dimBox).removeClass('show')
				this.defer(() => {
					if (this.lastMessage) {
						this.returnFocusToPage(this.lastMessage.focusedEl)

						if (typeof this.lastMessage.resolve === 'function') {
							this.lastMessage.resolve(button)
						}
					}
					var handle = button.handle
					if (handle != null) {
						this.defer(handle, 1, this.lastMessage, e)
						this.closeModalInner(e)
					}
				}, 300)
			},
			returnFocusToPage(jel) {
				if (this.messages.length <= 1 && jel && jel.length > 0) {
					this.defer(() => jel[0].focus(), 0)
				} else {
					this.defer(() => this.$el.focus(), 0)
				}
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'dialog-close',
					keyCode: 27, // 27:escape
					el: this.$el,
					context: this,
					autoRemove: false,
					handler: function (sender, e) {
						this.closeButtonClicked(e)
						return true
					}
				})

				this.$keyHandler.Subscribe({
					name: 'dialog-button-click',
					// keyCode: [32, 13], // 32:space and 13:enter
					el: this.$el,
					ctrlKey: undefined,
					altKey: undefined,
					shiftKey: undefined,
					context: this,
					handler: function (sender, e) {
						let button = _.head(this.localButtons.filter(b => {
							let keyCodes = Array.isArray(b.shortcut.keyCode) ? b.shortcut.keyCode : [b.shortcut.keyCode]
							return b.visible === true &&
								keyCodes.indexOf(e.keyCode) > -1 &&
								(b.shortcut.ctrlKey == null || b.shortcut.ctrlKey === e.ctrlKey) &&
								(b.shortcut.shiftKey == null || b.shortcut.shiftKey === e.shiftKey) &&
								(b.shortcut.altKey == null || b.shortcut.altKey === e.altKey)
						}))

						if (button) {
							e.preventDefault()
							this.buttonClicked(button, e)
							return true
						}
					}
				})

				TabOrder.subscribeKeys('dialog', this)
			}
		}
	}
</script>
<style src="~/styles/nikan-dialog.less" lang="less"></style>
